import { createFileRoute, Outlet } from '@tanstack/react-router'
import { SettingsShell } from '@bloo-team/core-shell'
import { identityFor, useSession } from '../../../lib/session'

/**
 * Settings — the platform layer, off the rail (docs/IA.md IA13). The frame
 * itself (strip, gated left nav, drill-down title channel) is
 * `@bloo-team/core-shell`'s `SettingsShell` since the E4 extraction; this route
 * only resolves the identity and mounts the section outlet inside it. The
 * gating composition lives in core-shell's `visibleGroups` (registry
 * composition ∩ role/gate filter) — see docs/settings.md.
 */
function SettingsLayout() {
  const { clusterId, scopeId } = Route.useParams()
  const session = useSession()
  const identity = session ? identityFor(session, clusterId, scopeId) : null

  return (
    <SettingsShell clusterId={clusterId} scopeId={scopeId} identity={identity}>
      <Outlet />
    </SettingsShell>
  )
}

export const Route = createFileRoute('/$clusterId/$scopeId/settings')({
  component: SettingsLayout,
})
